import React, { useContext, useEffect, useState } from "react";
import { AiOutlineLock, AiOutlineInfoCircle } from "react-icons/ai";
import ToggleSwitchCM from "../../components/ConsultationCard/ToogleSwitchCM";
import VerifyConfirmation from "../../components/confirmPopup/verifyconfirmation";
import { AppContext } from "../../appContext";
import { getUserApi, SendPayPageAuthApi, UpdateUserDetails, VerifyPayPageAuthApi } from "../../apis";
import toast from "react-hot-toast";

export default function PersonalSettingsSection() {
    const [paylocktoggle, setpaytoggle] = useState(true);
    const { loggedInUser} = useContext(AppContext);
    useEffect(() => {
        pageloadcall()
    }, []);
    const pageloadcall = async () => {
        const getprofile = await getUserApi();
        console.log("get profile details",getprofile)
        if (getprofile?.status === 200) {
            console.log(getprofile)
            const paylock = await getprofile?.data?.Profile?.hospitalProfile?.paylocktoggle;
            console.log("paylock", paylock)
            if (paylock || paylock === "true") {
                setpaytoggle(true)
            }
            else {
                setpaytoggle(false);
            }
        }

    }
    const handleToggle = () => {
        setisunlock(true);
    };
    const TriggerPaymentPageOTP = async () => {
        try {
            const res = await SendPayPageAuthApi({ hospitalId: loggedInUser?.data?.hospitalProfile?._id, PageAccess: false });
            if (res.status === 200) {
                console.log(res);
                toast.success(res.data.message);
                setverifyPage(true)
            }
        } catch (error) {
            console.log(error);
            const message = error?.response?.data.message || error?.response?.statusText;
            toast.error(message, { id: "error" });
        }
    };
    const [verifyPage, setverifyPage] = useState(false);
    const [isWrongOtp, setIsWrongOtp] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const VerifyPaymentPageOTP = async (otp) => {
        try {
            const res = await VerifyPayPageAuthApi({
                hospitalId: loggedInUser?.data?.hospitalProfile?._id,
                OTP: otp
            });
            if (res.status === 200) {
                console.log(res);
                const newValue = !paylocktoggle;
                const res2 = await UpdateUserDetails({ profileId: loggedInUser?.data?.hospitalProfile?._id, "paylocktoggle": newValue });
                if (res2.status === 200) {
                    setpaytoggle(newValue);
                    setisunlock(false);
                    setIsWrongOtp(false);
                    setErrorMsg("");
                }
            }
        } catch (error) {
            console.log(error);
            const message = error.response.data.message || error.response.statusText;
            toast.error(message, { id: "error" });
            setIsWrongOtp(true);
            setErrorMsg(message);
        }
    };
    const [isunlock, setisunlock] = useState(false);
    return (
        <>

            <section className="bg-white shadow-md rounded-xl p-6 max-w-xl mx-auto mt-10">
                {/* Top Toggle Row */}
                <div className="flex justify-between items-center border-b pb-4 mb-4">
                    <div className="flex items-center gap-2">
                        <AiOutlineLock size={20} className="text-blue-600" />
                        <p className="text-base font-medium text-gray-800 m-0">
                            Payment Lock Toggle
                        </p>
                    </div>
                    <ToggleSwitchCM state={paylocktoggle} togglefun={handleToggle} />
                </div>

                {/* Security Tip Box */}
                <div className="bg-blue-50 border border-blue-100 text-sm text-blue-900 rounded-lg p-4 flex items-start gap-3">
                    <AiOutlineInfoCircle size={20} className="mt-1 text-blue-500 flex-shrink-0" />
                    <div>
                        Payment lock provides additional security for your transactions. When enabled, the hospital payment page will require two-step verification to access and complete payments.
                    </div>
                </div>


            </section>
            {
                (loggedInUser?.data?.email && isunlock) &&
                <VerifyConfirmation
                    closefun={() => { setisunlock(false) }}
                    popupStatus={true}
                    email={loggedInUser?.data?.email}
                    onConfirm={() => { TriggerPaymentPageOTP() }}
                    handleClose={() => { alert("comming") }}
                    verifyPage={verifyPage}
                    onVerifyOtp={(otp) => { VerifyPaymentPageOTP(otp) }}
                    errorMsg={errorMsg}
                    setErrorMsg={setErrorMsg}
                    setIsWrongOtp={setIsWrongOtp}
                    isWrongOtp={isWrongOtp}
                    sendheader={
                        <p className="text-sm text-center text-gray-700">
                            To verify your identity and access this security settings <br />
                            Click <strong>"Send OTP"</strong> to receive a OTP  on {" "}

                        </p>
                    }
                    verifyheader={
                        <p className="text-sm text-center text-gray-700">
                            To access this security settings, please enter the otp sent to {" "}
                        </p>
                    }
                />
            }
        </>
    );
}
